var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51",
    height: "50",
    viewBox: "0 0 51 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25",
    fill: "#000",
    transform: "translate(.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1 14.83l-2.7 3.6 1.73-4.2c.04-.22.21-.35.34-.35.04 0 .08.05.16.09l.26.12.25.13c.22.14.18.35-.04.61zm-3.67 3.94l.76-6.04c.08-.43-.05-.73-.34-.73H25c-.3 0-.42.26-.34.73l.77 6.04zm1.05 6.56c.26.6.34.99.34 1.54V32.57c0 .22-.16.43-.42.43h-2.2c-.25 0-.42-.17-.42-.43V31.16H12.05V32.57c0 .22-.17.43-.42.43h-2.2c-.26 0-.43-.17-.43-.43V26.87c0-.56.08-.99.34-1.54l2.75-5.83a2.23 2.23 0 0 1 1.9-1.24h7.79c.76 0 1.61.56 1.95 1.24l2.75 5.83zm-15.03-.25h12.86l-1.86-4.03c-.38-.77-.71-.94-1.52-.94h-6.39c-.59.08-.89.3-1.18.94l-1.9 4.03zm1.78 2.91c0-.77-.63-1.37-1.4-1.37-.75 0-1.35.6-1.35 1.37 0 .77.6 1.42 1.36 1.42.76 0 1.4-.64 1.4-1.42zm12.1 0c0-.77-.63-1.37-1.4-1.37-.75 0-1.35.6-1.35 1.37 0 .77.6 1.42 1.36 1.42.76 0 1.4-.64 1.4-1.42zm-.84-9.18l-1.73-4.2c-.08-.22-.22-.34-.34-.34h-.13c-.04 0-.04.04-.08.04l-.25.13-.22.17c-.21.12-.16.34.05.6l2.7 3.6zm17.39 8.24l-1.27 4.84-.17.65c-.04.21-.3.34-.5.3l-2.12-.57c-.22-.04-.34-.3-.3-.51l.17-.64.21-.7-10.45-2.82v-.82c0-.34-.05-.72-.13-1.07a1.38 1.38 0 0 0 1.23-1.03c.21-.73-.26-1.5-.98-1.72-.46-.08-.93.05-1.27.35l-.98-2.06c.05-.04.08-.13.13-.17l4.14-4.89a2.33 2.33 0 0 1 2.17-.73l7.41 1.93c.76.22 1.44 1 1.56 1.72l1.19 6.35c.13.64.1 1.08-.04 1.59zm-1.82-2.23l-.8-4.37c-.17-.85-.47-1.11-1.23-1.33l-5.88-1.64c-.3-.08-.5-.08-.72-.08-.34.05-.63.26-.97.65l-2.88 3.38 12.48 3.4zm-.8 1.37c-.08-.04-.17-.04-.26-.04h-.25c-.55.04-1.02.43-1.14 1.03-.22.73.21 1.5.93 1.72.72.22 1.48-.26 1.7-1 .2-.73-.26-1.5-.98-1.7z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
});